import { __assign, __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { FieldActionType, FieldValueType, } from '../Fields';
import { getActionsForField, handleAddField, handleRemoveField, } from '../utils/FieldList.utils';
import { Cell, Layout } from 'wix-style-react';
import { EditContactEvent, } from '../../../constants/events';
import CustomField from '../CustomField/CustomField';
import BuiltInField from '../BuiltInField/BuiltInField';
var FieldList = /** @class */ (function (_super) {
    __extends(FieldList, _super);
    function FieldList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFieldAction = function (field, action) {
            _this.props.log(EditContactEvent.FIELD_ACTION_CLICK, {
                action: action.name,
                fieldName: field.id,
                fieldType: field.type,
            });
            switch (action.name) {
                case FieldActionType.ADD:
                    _this.addListToField({
                        name: field.id,
                        type: field.type,
                        unique: false,
                        isShown: true,
                    });
                    break;
                case FieldActionType.RENAME:
                    _this.props.onRenameCustomField({
                        id: field.id,
                        name: field.name,
                        type: field.customFieldType,
                        value: field.value,
                    });
                    break;
                case FieldActionType.REMOVE:
                    _this.removeFieldFromList(field);
                    break;
                default:
                    return;
            }
        };
        _this.removeFieldFromList = function (field) {
            var updateFields = _this.props.updateFields;
            var newFieldList = handleRemoveField(field, _this.props.fields, _this.props.newFields);
            updateFields(newFieldList.fields, newFieldList.newFields);
        };
        _this.addListToField = function (field) {
            var _a = _this.props, updateFields = _a.updateFields, fields = _a.fields, newFields = _a.newFields;
            var destructuredFieldList = __spreadArrays(fields);
            var destructuredNewFieldList = __spreadArrays(newFields);
            var updatedFieldList = handleAddField(field, destructuredFieldList, destructuredNewFieldList);
            if (updatedFieldList.newFields) {
                updateFields(updatedFieldList.fields, updatedFieldList.newFields);
            }
            else {
                updateFields(updatedFieldList.fields);
            }
        };
        _this.handleTagChange = function (field, tag) {
            var fields = _this.props.fields;
            var updatedFields = __spreadArrays(fields);
            var fieldIndex = fields.findIndex(function (f) {
                return f.id === field.id &&
                    f.index === field.index;
            });
            updatedFields[fieldIndex].value.tag = tag;
            _this.props.updateFields(updatedFields);
        };
        _this.handleValueChange = function (field, value) {
            var fields = _this.props.fields;
            var updatedFields = __spreadArrays(fields);
            var fieldIndex = _this.getFieldIndex(field);
            if (typeof value === 'string' ||
                typeof value === 'number' ||
                Array.isArray(value)) {
                updatedFields[fieldIndex].value = value;
            }
            else {
                updatedFields[fieldIndex].value = __assign(__assign({}, updatedFields[fieldIndex].value), value);
            }
            _this.props.updateFields(updatedFields);
        };
        _this.getFieldIndex = function (field) {
            var fields = _this.props.fields;
            if (field.list) {
                return fields.findIndex(function (f) {
                    return f.id === field.id &&
                        f.index === field.index;
                });
            }
            return fields.findIndex(function (f) { return f.id === field.id; });
        };
        return _this;
    }
    FieldList.prototype.renderBuildInField = function (field, opts) {
        var _this = this;
        if (opts === void 0) { opts = {
            required: false,
        }; }
        var _a = this.props, countries = _a.countries, labels = _a.labels, assigneeComponent = _a.assigneeComponent, log = _a.log, contactId = _a.contactId, fields = _a.fields;
        var key = field.type === FieldValueType.ASSIGNEES
            ? 'Assignee'
            : field.id + "-" + field.index;
        return (React.createElement(Cell, { key: key },
            React.createElement(BuiltInField, { contactId: contactId, key: key, field: field, onFieldTagChange: function (value) { return _this.handleTagChange(field, value); }, onFieldValueChange: function (value) { return _this.handleValueChange(field, value); }, onFieldActionClick: function (action) { return _this.handleFieldAction(field, action); }, countries: countries, labels: labels, actions: getActionsForField(field, fields), log: log, assigneeComponent: assigneeComponent, required: opts.required, errorField: this.props.errorField, validationError: this.props.validationError, onCheckForDuplicateEmail: this.props.onCheckForDuplicateEmail })));
    };
    FieldList.prototype.renderCustomField = function (field, index) {
        var _this = this;
        return (React.createElement(Cell, { key: field.id + "-" + index },
            React.createElement(CustomField, { field: field, onFieldValueChange: function (changedField, value) {
                    return _this.handleValueChange(changedField, value);
                }, onActionClicked: function (action) { return _this.handleFieldAction(field, action); } })));
    };
    FieldList.prototype.updateRequiredFields = function (fieldId, requiredFields) {
        var requiredIndex = requiredFields.findIndex(function (f) { return f === fieldId; });
        if (requiredIndex !== -1) {
            requiredFields.splice(requiredIndex, 1);
        }
        return requiredFields;
    };
    FieldList.prototype.render = function () {
        var _this = this;
        var fields = this.props.fields;
        var requiredFields = [];
        if (this.props.requiredFields && this.props.requiredFields.length) {
            requiredFields = __spreadArrays(this.props.requiredFields);
        }
        return (React.createElement(Layout, null, fields.map(function (field, index) {
            if (field.isBuildInField) {
                var isFieldRequired = false;
                if (requiredFields.includes(field.id)) {
                    isFieldRequired = true;
                    requiredFields = _this.updateRequiredFields(field.id, requiredFields);
                }
                return _this.renderBuildInField(field, {
                    required: isFieldRequired,
                });
            }
            return _this.renderCustomField(field, index);
        })));
    };
    return FieldList;
}(React.Component));
export { FieldList };
export default translate()(FieldList);
//# sourceMappingURL=FieldList.js.map